import React from "react"
import { Box, ButtonBase, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { dsColorNew } from "@palette"


// Two-or-more option chips with an icon, from the Dataseekers retail front ("All / Only Stock").
// Each option is a real button, so it keeps the keyboard access of the switch it replaces.
// options: [{ value, label, icon? }] — values can be booleans for a yes / no setting.
export default function AppIconChipToggle({ value, options = [], onChange, disabled = false, size = 'medium', ...props }) {
	const small = size === 'small'

	return <Box role="group" {...props} sx={{
		display: 'inline-flex',
		gap: '4px',
		p: small ? '3px' : '4px',
		borderRadius: small ? '10px' : '12px',
		backgroundColor: dsColorNew.pillTrackBg,
		border: `1px solid ${dsColorNew.grayBorder}`,
		...(disabled && { opacity: 0.55 }),
		...props?.sx,
	}}>
		{options.map(option => {
			const isActive = option.value === value
			const color = isActive ? dsColorNew.appBlue : dsColorNew.textSubtle

			return <ButtonBase
				key={String(option.value)}
				aria-pressed={isActive}
				disabled={disabled}
				onClick={() => !isActive && onChange(option.value)}
				sx={{
					gap: small ? '6px' : '8px',
					px: small ? '10px' : '12px',
					py: small ? '6px' : '8px',
					borderRadius: small ? '8px' : '10px',
					transition: 'all 0.15s ease',
					'&.Mui-focusVisible': { outline: `2px solid ${dsColorNew.webBlue500}`, outlineOffset: 1 },
					...(isActive
						? { backgroundColor: dsColorNew.pillActiveBg, border: `1.5px solid ${dsColorNew.appBlue}` }
						: { backgroundColor: dsColorNew.filterInputBg, border: `1px solid ${dsColorNew.grayBorder}` }),
				}}
			>
				{!!option.icon && <IconSeeker icon={option.icon} sx={{ fontSize: small ? 13 : 16, color }}/>}
				<Typography sx={{ fontSize: small ? 13 : 14, fontWeight: isActive ? 600 : 500, color, lineHeight: 1, whiteSpace: 'nowrap' }}>
					{option.label}
				</Typography>
			</ButtonBase>
		})}
	</Box>
}
